import { Button, ModalBody, ModalFooter, Text } from '@chakra-ui/react';
import Balance from '@ui/components/Balance/Balance';
import { useStrategyTokenUsdValue } from '@ui/hooks/useStrategyTokenUsdValue';
import { useTranslations } from '@ui/i18n';
import { parseValue } from '@ui/utils/format';
import {
  LiquidityStrategyTokenDict,
  useDepositTokenBalanceUsd,
} from '@ui/utils/strategy';

import { useDepositDrawer } from './useDepositDrawer';

export const SuccessContent = () => {
  const t = useTranslations();

  const onClose = useDepositDrawer((s) => s.onClose);
  const amountStr = useDepositDrawer((s) => s.amountStr);
  const token = useDepositDrawer((s) => s.token);
  // follow design
  const amountBn = parseValue(amountStr, 18);
  const amountUsd = useDepositTokenBalanceUsd({
    token,
    amount: amountBn,
  });
  const isWithdraw = useDepositDrawer((s) => s.isWithdraw);

  const tokenInfo = LiquidityStrategyTokenDict[token];

  const receivedAmount = useDepositDrawer((s) => s.receivedAmount);
  const receivedAmountWithdrawUsd = useDepositTokenBalanceUsd({
    token,
    amount: isWithdraw ? receivedAmount : undefined,
  });

  const receivedAmountDepositUsd = useStrategyTokenUsdValue(
    !isWithdraw ? receivedAmount : undefined,
  );

  return (
    <>
      <ModalBody display="flex" flexDir="column" alignItems="center">
        <Text textStyle="h3" textAlign="center">
          {t('Transaction completed!')}
        </Text>
        {!isWithdraw && (
          <Balance
            title={t('You have deposited')}
            icon={<tokenInfo.Icon width="32px" height="32px" />}
            amount={amountBn}
            unitDecimals={tokenInfo.decimals}
            usdAmount={amountUsd}
            usdDisplayDecimals={2}
            showUsdAmount
            mt="24px"
          />
        )}
        <Balance
          title={
            t('You have received') +
            (isWithdraw ? '' : ' ' + tokenInfo.vaultTokenName)
          }
          icon={
            isWithdraw ? (
              <tokenInfo.Icon width="32px" height="32px" />
            ) : undefined
          }
          amount={receivedAmount}
          unitDecimals={tokenInfo.decimals}
          usdAmount={
            isWithdraw
              ? receivedAmountWithdrawUsd
              : receivedAmountDepositUsd ?? undefined
          }
          usdDisplayDecimals={2}
          showUsdAmount
          mt="24px"
        />
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>{t('Done')}</Button>
      </ModalFooter>
    </>
  );
};
